import React from "react"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import Icon from "../../icon/icon.component"
import AccountService from "../../../state/account/service"
import { useQuery } from "react-query"
import { FormattedMessage } from "react-intl"


const EnvironmentBannerComponent = () => {
    const session = AppContext.getSession()
    const impersonateAccountId = session?.attributes.impersonateAccountId

    const {data} = useQuery(["account", impersonateAccountId], () => AccountService.get(impersonateAccountId), {
        enabled: !!impersonateAccountId
    })


    let impersonation: unknown
    if (data) {
        impersonation =
            <p className="mb-0 text-align-center impersonation bg-primary rounded p-1 offset-4 w-25 d-flex align-items-center">
                <FormattedMessage
                    id="main.sidebar.impersonation"
                    defaultMessage="Logged as {accountName}"
                    values={{
                        accountName: <strong>{data.getCompanyName()}</strong>
                    }}
                /> / Account ID: {data.getId()}
                <br/>
                <a href="/impersonate/stop">
                    <Icon value="door-closed"/>
                </a>
            </p>
    }


    const env = AppContext.getOptions().environment
    if (env === "dev" || env === "staging" || env === "release-candidate" || impersonation) {
        const title = env.toUpperCase() + " ENVIRONMENT"
        let bg = "bg-info"
        let color = "white"
        switch (env) {
        case "dev":
            bg = "bg-info"
            color = "white"
            break
        case "staging":
            bg = "bg-warning"
            color = "black"
            break
        case "release-candidate":
            bg = "bg-secondary"
            color = "white"
            break
        case "prod":
            bg = "bg-primary"
            color = "white"
            break
        }

        return (
            <div className={"position-fixed col-12 " + bg} style={{
                top: "0px",
                zIndex: 1500,
                left: "0px",
                height: "7px",
                fontSize: "6px",
                color: color,
                textAlign: "center"}}
            >
                {title}
                {impersonation}
            </div>
        )
    }
    return <></>
}

export default EnvironmentBannerComponent


// WEBPACK FOOTER //
// ./src/common/layout/components/EnvironmentBannerComponent.tsx